/**
 * Create store system normal interfceSettings
 *
 * @since 2018-04-30
 * @author jongsung.Lee(devp010)
 */

// import
import {SystemApiPrefix as smApiPrefix} from 'utils'

// const
export const state = () => ({
  apiUrlPath: {
    'interfaceConfig': `${smApiPrefix}/interfaces/{id}/config`, //              interfaces config
    'interfaceConfigApply': `${smApiPrefix}/interfaces/{id}/config/apply`, //   interfaces config apply
    'interfaceConfigCancel': `${smApiPrefix}/interfaces/{id}/config/cancel`, // interfaces config cancel
    'bridgeIfs': `${smApiPrefix}/bridge/interfaces`, //                             bridge interface
    'bridgeConfig': `${smApiPrefix}/bridge/interfaces/{id}/config`, //              bridge config
    'bridgeConfigApply': `${smApiPrefix}/bridge/interfaces/{id}/config/apply`, //   bridge config apply
    'bridgeConfigCancel': `${smApiPrefix}/bridge/interfaces/{id}/config/cancel`, // bridge config cancel
    'trunkIfs': `${smApiPrefix}/trunk/interfaces`, //                             trunk interface
    'trunkConfig': `${smApiPrefix}/trunk/interfaces/{id}/config`, //              trunk config
    'trunkConfigApply': `${smApiPrefix}/trunk/interfaces/{id}/config/apply`, //   trunk config apply
    'trunkConfigCancel': `${smApiPrefix}/trunk/interfaces/{id}/config/cancel` //  trunk config cancel
  },
  // session type of pppoe // static: 1, dynamic: 2, unnumbered: 3
  sessionTypePppoe: [
    {label: 'static', value: 1},
    {label: 'dynamic', value: 2},
    {label: 'unnumbered', value: 3}
  ],
  // interfaces // >>>>>>>>>>>>>>>>>>>> interface Tab > normal popup
  interfaceNormalConfig: {
    id: 0,
    name: '',
    zone: '',
    mode: {
      mode: '',
      type: '',
      static: {
        type: '',
        ipv4: '',
        ipv6: [],
        aliases: []
      },
      dhcp: {
        request_dns: 0,
        request_defaultgw: 0
      },
      pppoe: [],
      mirror: {
        target_name: '',
        interface_id: 0,
        incoming: 0,
        outgoing: 0
      },
      nac: {
        static_address_set: 0,
        ip: ''
      }
    },
    slave_interfaces: [],
    balance_mode: { // (Round Robin: 1, XOR: 2, Active Backup: 3, 802.3ad: 4)
      mode: 1,
      active_interface_name: '',
      active_interface_id: 0,
      fast_mode: 1,
      packet_dist: 1
    },
    vlans: [],
    status: {}
  },
  // clone
  normalZoneClone: {},
  normalSlaveClone: {},
  normalIfModeClone: {},
  normalBalanceClone: {},
  normalStatusClone: {},
  normalVlanClone: {},
  // alias ip
  aliasIpv4: {alias_id: 0, alias_ip: ''},
  aliasIpv6: {ipv6_id: 0, ipv6_ip: ''},
  pppoeSessionInfo: {
    session_id: 0,
    session_name: '',
    session_type: '',
    session_username: '',
    session_passwd: '',
    session_ip_addr: '',
    session_req_dns: 0,
    session_req_defaultgw: 0
  }, // mirror candidates
  mirrorCandidates: [
    {id: 0, label: '', value: ''}
  ],
  slaveInterfaceCandidates: [], // slave interface candidates {id: 0, name: '', zone: 0}
  selectedSlaveInterfaces: [], // selected slave interfaces {id: 0, name: '', zone: 0}
  activeInterfaceCandidates: [] // active candidates {id: 0, label: '', value: ''}
  // <<<<<<<<<<<<<<<<<<<< interface Tab > normal popup
})

export const mutations = {
  clearPppoeDialog (state) {
    state.selectedItem = ''
    state.pppoeSessionInfo.session_id = 0
    state.pppoeSessionInfo.session_name = ''
    state.pppoeSessionInfo.session_type = ''
    state.pppoeSessionInfo.session_username = ''
    state.pppoeSessionInfo.session_passwd = ''
    state.pppoeSessionInfo.session_ip_addr = ''
    state.pppoeSessionInfo.session_req_dns = 0
    state.pppoeSessionInfo.session_req_defaultgw = 0
  },
  setPppoeDialog (state, data) {
    if (data !== undefined) {
      state.selectedItem = data
      state.pppoeSessionInfo.session_id = data.session_id
      state.pppoeSessionInfo.session_name = data.session_name
      state.pppoeSessionInfo.session_type = data.session_type
      state.pppoeSessionInfo.session_username = data.session_username
      // not get
      state.pppoeSessionInfo.session_passwd = ''
      state.pppoeSessionInfo.session_ip_addr = data.session_ip_addr
      state.pppoeSessionInfo.session_req_dns = data.session_req_dns
      state.pppoeSessionInfo.session_req_defaultgw = data.session_req_defaultgw
    }
  },
  // reset interface normal config
  resetInterfaceNormalConfig (state) {
    // default config
    state.interfaceNormalConfig.id = 0
    state.interfaceNormalConfig.name = ''
    // zone
    state.interfaceNormalConfig.zone = ''
    // mode
    state.interfaceNormalConfig.mode = {
      mode: '',
      type: '',
      static: {
        type: '',
        ipv4: '',
        ipv6: [],
        aliases: []
      },
      dhcp: {
        request_dns: 0,
        request_defaultgw: 0
      },
      pppoe: [],
      mirror: {
        target_name: '',
        interface_id: 0,
        incoming: 0,
        outgoing: 0
      },
      nac: {
        ipv4ipval: '',
        ipv4maskval: null,
        static_address_set: 0,
        ip: ''
      }
    }
    // slave interface
    state.interfaceNormalConfig.slave_interfaces = []
    // balance
    state.interfaceNormalConfig.balance_mode = {
      mode: 1,
      active_interface_name: '',
      active_interface_id: 0,
      fast_mode: 1,
      packet_dist: 1
    }
    state.interfaceNormalConfig.vlans = []
    state.interfaceNormalConfig.status = {}
  },
  // set interface normal config
  setInterfaceNormalConfig (state, data) {
    // default config
    state.interfaceNormalConfig.id = data.id
    state.interfaceNormalConfig.name = data.name
    // zone
    if (data.zone !== undefined) {
      state.interfaceNormalConfig.zone = data.zone
    }
    // mode
    if (data.mode !== undefined) {
      state.interfaceNormalConfig.mode.mode = data.mode.mode
      state.interfaceNormalConfig.mode.type = data.mode.type
      if (data.mode.static !== undefined) {
        state.interfaceNormalConfig.mode.static = data.mode.static
      }
      if (data.mode.dhcp !== undefined) {
        state.interfaceNormalConfig.mode.dhcp = data.mode.dhcp
      }
      if (data.mode.pppoe !== undefined) {
        state.interfaceNormalConfig.mode.pppoe = data.mode.pppoe
      }
      if (data.mode.mirror !== undefined) {
        state.interfaceNormalConfig.mode.mirror.target_name = data.mode.mirror.target_name
        state.interfaceNormalConfig.mode.mirror.interface_id = data.mode.mirror.interface_id
        state.interfaceNormalConfig.mode.mirror.incoming = data.mode.mirror.incoming
        state.interfaceNormalConfig.mode.mirror.outgoing = data.mode.mirror.outgoing
      }
      // nac mode
      if (data.mode.nac !== undefined) {
        if (data.mode.nac.static_address_set !== undefined) {
          state.interfaceNormalConfig.mode.nac.static_address_set = data.mode.nac.static_address_set
        }
        if (data.mode.nac.ipv4 !== undefined) {
          state.interfaceNormalConfig.mode.nac.ipv4ipval = _.split(data.mode.nac.ipv4, '/', 1)[0]
          state.interfaceNormalConfig.mode.nac.ipv4maskval = (_.lastIndexOf(data.mode.nac.ipv4, '/') > 0) ? Number(_.split(data.mode.nac.ipv4, '/', 2)[1]) : 0
          state.interfaceNormalConfig.mode.nac.ipv4 = data.mode.nac.ipv4
        }
      }
    }
    if (data.slave_interfaces !== undefined) {
      for (const sl of data.slave_interfaces) {
        state.interfaceNormalConfig.slave_interfaces.push({id: sl.id, name: sl.name, zone: sl.zone, used: true})
      }
    }
    if (data.balance_mode !== undefined) {
      // balance mode
      state.interfaceNormalConfig.balance_mode.mode = data.balance_mode.mode
      state.interfaceNormalConfig.balance_mode.active_interface_name = data.balance_mode.active_interface_name
      state.interfaceNormalConfig.balance_mode.active_interface_id = data.balance_mode.active_interface_id
      state.interfaceNormalConfig.balance_mode.fast_mode = data.balance_mode.fast_mode
      state.interfaceNormalConfig.balance_mode.packet_dist = data.balance_mode.packet_dist
    }
    if (data.status !== undefined) {
      state.interfaceNormalConfig.status = data.status
    }
    if (data.vlans !== undefined) {
      state.interfaceNormalConfig.vlans = data.vlans
    }
  },
  // set clone interface-advance config by tabs
  setCloneInterfaceNormalConfig (state, ifTypeName) {
    // zone
    state.normalZoneClone = _.cloneDeep(state.interfaceNormalConfig.zone)
    // mode
    state.normalIfModeClone = _.cloneDeep(state.interfaceNormalConfig.mode)
    if (ifTypeName === 'bridge' || ifTypeName === 'trunk') {
      // slave
      state.normalSlaveClone = _.cloneDeep(state.interfaceNormalConfig.slave_interfaces)
      for (const sl of state.normalSlaveClone) {
        sl.used = true
      }
    }
    if (ifTypeName === 'trunk') {
      // balance
      state.normalBalanceClone = _.cloneDeep(state.interfaceNormalConfig.balance_mode)
    }
    // status
    state.normalStatusClone = _.cloneDeep(state.interfaceNormalConfig.status)
    // vlan
    state.normalVlanClone = _.cloneDeep(state.interfaceNormalConfig.vlans)
  },
  resetAliasIpv4 (state) {
    state.aliasIpv4.alias_id = 0
    state.aliasIpv4.alias_ip = ''
  },
  setAliasIpv4 (state, data) {
    if (data !== undefined) {
      state.aliasIpv4.alias_id = data.alias_id
      state.aliasIpv4.alias_ip = data.alias_ip
    }
  },
  addAliasIpv4 (state, data) {
    if (data !== undefined) {
      if (state.interfaceNormalConfig.mode.static === undefined) {
        state.interfaceNormalConfig.mode = {
          static: {
            type: 'static',
            ipv4: undefined
          }
        }
      }
      if (state.interfaceNormalConfig.mode.static.alias === undefined) {
        state.interfaceNormalConfig.mode.static.alias = []
      }
      state.interfaceNormalConfig.mode.static.alias.push(data)
    }
  },
  delAliasIpv4  (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.interfaceNormalConfig.mode.static.alias.splice(item.itemIndex, 1)
      }
    }
  },
  resetStaticIpv6 (state) {
    state.aliasIpv6.ipv6_id = 0
    state.aliasIpv6.ipv6_ip = ''
  },
  setStaticIpv6 (state, data) {
    if (data !== undefined) {
      state.aliasIpv6.ipv6_id = data.ipv6_id
      state.aliasIpv6.ipv6_ip = data.ipv6_ip
    }
  },
  addStaticIpv6 (state, data) {
    if (data !== undefined) {
      if (state.interfaceNormalConfig.mode.static === undefined) {
        state.interfaceNormalConfig.mode = {
          static: {
            type: 'static',
            ipv4: undefined
          }
        }
      }
      if (state.interfaceNormalConfig.mode.static.ipv6 === undefined) {
        state.interfaceNormalConfig.mode.static.ipv6 = []
      }
      state.interfaceNormalConfig.mode.static.ipv6.push(data)
    }
  },
  delStaticIpv6  (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.interfaceNormalConfig.mode.static.ipv6.splice(item.itemIndex, 1)
      }
    }
  },
  resetPppoeSession (state) {
    state.pppoeSessionInfo.session_id = 0
    state.pppoeSessionInfo.session_name = ''
    state.pppoeSessionInfo.session_userId = ''
    state.pppoeSessionInfo.session_passwd = ''
    state.pppoeSessionInfo.session_ip_addr = ''
    state.pppoeSessionInfo.session_req_dns = 0
    state.pppoeSessionInfo.session_req_defaultgw = 0
  },
  setPppoeSession (state, data) {
    if (data !== undefined) {
      state.pppoeSessionInfo.session_id = data.session_id
      state.pppoeSessionInfo.session_name = data.session_name
      state.pppoeSessionInfo.session_userId = data.session_userId
      state.pppoeSessionInfo.session_passwd = data.session_passwd
      state.pppoeSessionInfo.session_ip_addr = data.session_ip_addr
      state.pppoeSessionInfo.session_req_dns = data.session_req_dns
      state.pppoeSessionInfo.session_req_defaultgw = data.session_req_defaultgw
    }
  },
  addPppoeSession (state, data) {
    if (data !== undefined) {
      state.interfaceNormalConfig.mode.pppoe.push(data)
    }
  },
  edtPppoeSession (state, item) {
    const findRslt = _.find(state.interfaceNormalConfig.mode.pppoe, {session_id: item.session_id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.interfaceNormalConfig.mode.pppoe.splice(findRslt.itemIndex, 1, item)
    }
  },
  delPppoeSession  (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.interfaceNormalConfig.mode.pppoe.splice(item.itemIndex, 1)
      }
    }
  },
  resetMirrorCandidates (state) {
    state.mirrorCandidates = []
  },
  setMirrorCandidates (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const candi of data) {
        state.mirrorCandidates.push({
          id: candi.id,
          label: candi.name,
          value: candi.name
        })
      }
    }
  },
  resetSlaveInterfaceCandidates (state) {
    state.slaveInterfaceCandidates = []
  },
  setSlaveInterfaceCandidates (state, rslt) {
    if (rslt.result !== undefined && (rslt.result).length > 0) {
      const ifType = rslt.iftype
      for (const slave of rslt.result) {
        if (!(slave.zone > 0)) continue
        // check targetType ( type: 1-interface, 2-bridge, 3-trunk )
        if (ifType.toLowerCase() === 'bridge' && slave.type !== undefined && slave.type === 2) {
          // bridge -> slave type: 1 or 3
        } else if (ifType.toLowerCase() === 'trunk' && slave.type !== undefined && slave.type !== 1) {
          // trunk -> slave type: 1
        } else {
          state.slaveInterfaceCandidates.push({
            id: slave.id,
            name: slave.name,
            zone: slave.zone,
            used: false
          })
        }
      }
    }
  },
  // selected interface list
  setSelectedSlaveIfList (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const slave of data) {
        state.selectedSlaveInterfaces.push({
          id: slave.id,
          name: slave.name,
          zone: slave.zone,
          used: true
        })
      }
    }
  },
  resetActiveInterfaceCandidates (state) {
    state.activeInterfaceCandidates = []
  },
  setActiveInterfaceCandidates (state, data) {
    state.activeInterfaceCandidates = data
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>> get interface normal config
  async getInterfaceNorConfig ({commit, state}, param) {
    const res = {code: 'nok'}
    try {
      // REAL CODE
      const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId)
      const configData = await this.$axios.$get(apiUrlStr)
      if (_.get(configData, 'code', '').toLowerCase() !== 'ok') {
        return { code: 'nok', reason: configData.code }
      }
      res.code = 'ok'
      // reset
      commit('resetInterfaceNormalConfig')

      // reset ipv4 form
      if (configData.result.mode.static === undefined) {
        configData.result.mode.static = {}
        if (configData.result.mode.mode !== undefined && configData.result.mode.mode === 1) {
          configData.result.mode.static.alias = []
          configData.result.mode.static.ipv6 = []
        }
      }
      configData.result.mode.static.ip4ipval = undefined
      configData.result.mode.static.ip4maskval = undefined
      if (configData.result.mode.static.ipv4 !== undefined && configData.result.mode.static.ipv4 !== '') {
        configData.result.mode.static.ip4ipval = _.split(configData.result.mode.static.ipv4, '/', 1)[0]
        configData.result.mode.static.ipv4maskval = (_.lastIndexOf(configData.result.mode.static.ipv4, '/') > 0) ? Number(_.split(configData.result.mode.static.ipv4, '/', 2)[1]) : 0
      } else {
        configData.result.mode.static.ip4ipval = null
        configData.result.mode.static.ipv4maskval = null
      }
      commit('setInterfaceNormalConfig', configData.result)
      // copy original config by clone
      commit('setCloneInterfaceNormalConfig', param.ifType)
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.toString()
      return res
    }
  },
  async editNormalConfig ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId)
    delete param.ifId
    delete param.ifType
    const data = await this.$axios.$put(apiUrlStr, param, {loadingHide: false, successAlert: false})
    if (data.code !== undefined && data.code === 'ok') {
      res.code = 'ok'
    } else {
      res.code = 'nok'
      res.reason = data.code
    }
    return res
  },
  async addAliasIpv4 ({commit, state}, param) {
    const res = {code: 'nok'}
    const postParam = {
      alias_ip: param.alias_ip
    }
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId).concat('/aliases')
    const addRslt = await this.$axios.$post(apiUrlStr, postParam)
    if (addRslt.code !== undefined && (addRslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      commit('addAliasIpv4', addRslt.result)
      // dispatch common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.code = 'nok'
      res.reason = addRslt.code
    }
    return res
  },
  async delAliasIpv4 ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.id).concat('/aliases')
    const delRslt = await this.$axios.$delete(apiUrlStr.concat(`/${param.idList[0].alias_id}`))
    if (delRslt.code !== undefined && (delRslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // reset
      commit('delAliasIpv4', param.itemIndexList)
      // dispatch common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.code = 'nok'
      res.reason = delRslt.code
    }
    return res
  },
  async addStaticIpv6 ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId).concat('/ipv6s')
    const addRslt = await this.$axios.$post(apiUrlStr, {ipv6_ip: param.ipv6_ip})
    if (addRslt.code !== undefined && (addRslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      commit('addStaticIpv6', addRslt.result)
      // dispatch common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.code = 'nok'
      res.reason = addRslt.code
    }
    return res
  },
  async delStaticIpv6 ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.id).concat('/ipv6s')
    const delRslt = await this.$axios.$delete(apiUrlStr.concat(`/${param.idList[0].ipv6_id}`))
    if (delRslt.code !== undefined && (delRslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // reset
      commit('delStaticIpv6', param.itemIndexList)
      // dispatch common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.code = 'nok'
      res.reason = delRslt.code
    }
    return res
  },
  async addPppoeSession ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId).concat('/pppoes')
    const addParam = _.cloneDeep(state.pppoeSessionInfo)
    delete addParam.pppoe_id
    // base64 for password
    addParam.session_passwd = btoa(state.pppoeSessionInfo.session_passwd)
    const addRslt = await this.$axios.$post(apiUrlStr, addParam)
    if (addRslt.code !== undefined && (addRslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      addRslt.result.session_name = state.pppoeSessionInfo.session_name
      addRslt.result.session_username = state.pppoeSessionInfo.session_username
      // not get
      addRslt.result.session_passwd = '' // state.pppoeSessionInfo.session_passwd
      addRslt.result.session_ip_addr = state.pppoeSessionInfo.session_ip_addr
      addRslt.result.session_req_dns = state.pppoeSessionInfo.session_req_dns
      addRslt.result.session_req_defaultgw = state.pppoeSessionInfo.session_req_defaultgw
      commit('addPppoeSession', addRslt.result)
      // dispatch common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.code = 'nok'
      res.reason = addRslt.code
    }
    return res
  },
  async edtPppoeSession ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrl = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId).concat(`/pppoes/${state.pppoeSessionInfo.session_id}`)
    const putParam = {
      session_id: state.pppoeSessionInfo.session_id,
      session_name: state.pppoeSessionInfo.session_name,
      session_type: state.pppoeSessionInfo.session_type,
      session_username: state.pppoeSessionInfo.session_username,
      session_passwd: state.pppoeSessionInfo.session_passwd,
      session_ip_addr: state.pppoeSessionInfo.session_ip_addr,
      session_req_dns: state.pppoeSessionInfo.session_req_dns,
      session_req_defaultgw: state.pppoeSessionInfo.session_req_defaultgw
    }
    if ((putParam.session_passwd).length === 0) {
      delete putParam.session_passwd
    } else {
      // base64 for password ( only modify password )
      putParam.session_passwd = btoa(putParam.session_passwd)
    }
    const data = await this.$axios.$put(apiUrl, putParam)

    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      commit('edtPppoeSession', putParam)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.reason = data.code
    }
    return res
  },
  async delPppoeSession ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.id).concat('/pppoes')
    // just one-row delete
    const delRslt = await this.$axios.$delete(apiUrlStr.concat(`/${param.idList[0].session_id}`))
    if (delRslt.code !== undefined && (delRslt.code).toLowerCase() === 'ok') {
      res.code = 'ok'
      // reset
      commit('delPppoeSession', param.itemIndexList)
      // dispatch common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
    } else {
      res.code = 'nok'
      res.reason = delRslt.code
    }
    return res
  },
  // interface normal config apply & cancel
  async applyIfNormalConfig ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrl = _.replace(state.apiUrlPath[`${param.ifType}ConfigApply`], '{id}', param.ifId)
    const rsltData = await this.$axios.$put(apiUrl, null, {applyMsg: true})
    if (rsltData.code === 'ok') {
      res.code = 'ok'
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      // re set configClon
      commit('setCloneInterfaceNormalConfig', param.ifType)
    } else {
      res.code = 'nok'
      res.reason = rsltData.code
    }
    return res
  },
  async cancelIfNormalConfig ({commit, state}, param) {
    const res = {code: 'nok'}
    const apiUrl = _.replace(state.apiUrlPath[`${param.ifType}ConfigCancel`], '{id}', param.ifId)
    const rsltData = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
    if (rsltData.code === 'ok') {
      res.code = 'ok'
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      // re set configClon
      commit('setCloneInterfaceNormalConfig', param.ifType)
    } else {
      res.code = 'nok'
      res.reason = rsltData.code
    }
    return res
  },
  // get mirror Candidates
  async getMirrorCandidates ({commit, state}, param) {
    const res = {code: 'nok'}
    try {
      const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId).concat('/mirror-candidates')
      const {code, result} = await this.$axios.$get(apiUrlStr)
      if (code !== undefined && code === 'ok') {
        res.code = 'ok'
        commit('resetMirrorCandidates')
        commit('setMirrorCandidates', result)
      } else {
        res.code = 'nok'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = (e.message !== undefined) ? e.message : ((e !== undefined) ? e.toString() : 'error')
      return res
    }
  },
  // get slave interfaces Candidates
  async getSlaveInterfaceCandidates ({commit, state}, param) {
    const res = {code: 'nok'}
    try {
      const apiUrlStr = (state.apiUrlPath[`${param.ifType}Ifs`]).concat('/slave-candidates')
      const {code, result} = await this.$axios.$get(apiUrlStr)
      if (code !== undefined && code === 'ok') {
        res.code = 'ok'
        const rsltObj = {
          result: result,
          iftype: param.ifType
        }
        commit('resetSlaveInterfaceCandidates')
        commit('setSlaveInterfaceCandidates', rsltObj)
      } else {
        res.code = 'nok'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = (e.message !== undefined) ? e.message : ((e !== undefined) ? e.toString() : 'error')
      return res
    }
  },
  // get active interfaces Candidates
  async getActiveInterfaceCandidates ({commit, state}, param) {
    const res = {code: 'nok'}
    try {
      // REAL CODE
      const apiUrlStr = _.replace(state.apiUrlPath[`${param.ifType}Config`], '{id}', param.ifId).concat('/active-candidates')
      const {code, result} = await this.$axios.$get(apiUrlStr)
      if (code !== undefined && code === 'ok') {
        res.code = 'ok'
        commit('resetActiveInterfaceCandidates')
        commit('setActiveInterfaceCandidates', result)
      } else {
        res.code = 'nok'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = (e.message !== undefined) ? e.message : ((e !== undefined) ? e.toString() : 'error')
      return res
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<< get interface normal config
}

export const getters = {}
export const strict = false
